"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useCardStyle = ({ disabled, selected }) => {
    const theme = (0, material_1.useTheme)();
    const buttonBaseStyle = {
        width: '100%',
        cursor: disabled ? 'default' : 'pointer',
    };
    const cardStyles = {
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '8px 16px',
        gap: '16px',
        width: '100%',
        justifyContent: 'space-between',
        height: '48px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        background: disabled
            ? theme.qlub.palette.dim.main
            : selected
                ? theme.palette.secondary.main
                : theme.qlub.palette.white.main,
        border: `1px solid ${theme.qlub.palette.dim.main}`,
        borderRadius: '8px',
    };
    const creditCardsStyles = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '0px',
        gap: '8px',
        height: '32px',
        '& svg': {
            filter: disabled && 'grayscale(100%)',
            opacity: disabled && '0.7',
        },
    };
    const circleIconStyles = {
        color: selected ? theme.palette.primary.main : theme.qlub.palette.dim.main,
    };
    const selectCardStyles = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '0px',
        gap: '8px',
        height: '24px',
    };
    const cardTextStyles = Object.assign(Object.assign({}, theme.qlub.typography.body_sm), { fontFamily: 'inherit', display: 'flex', alignItems: 'center', letterSpacing: '0.0025em', color: disabled ? theme.qlub.palette.onSurfaceColors.disabled : theme.qlub.palette.onSurfaceColors.highEmphasis });
    const creditCardStyles = {};
    return {
        cardStyles,
        circleIconStyles,
        creditCardsStyles,
        selectCardStyles,
        cardTextStyles,
        creditCardStyles,
        buttonBaseStyle,
    };
};
exports.default = useCardStyle;
